import React from 'react';
import { getUserDisplayName, getUserInitials } from '../../utils/auth';

/**
 * UserAvatar Component - Displays user profile picture or initials
 * @param {Object} user - User object with profilePicturePath
 * @param {string} size - Size class (sm, md, lg, xl)
 * @param {boolean} showBorder - Whether to show border
 * @param {string} className - Additional CSS classes
 */
const UserAvatar = ({ 
  user, 
  size = 'md', 
  showBorder = true, 
  className = '',
  onClick 
}) => {
  if (!user) {
    return (
      <div className={`w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center ${className}`}>
        <span className="text-gray-600 text-xs font-semibold">?</span>
      </div>
    );
  }

  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-lg'
  };

  const borderClass = showBorder ? 'border-2 border-white shadow-sm' : '';

  if (user.profilePicturePath) {
    return (
      <div 
        className={`${sizeClasses[size].split(' ')[0]} ${sizeClasses[size].split(' ')[1]} rounded-full overflow-hidden ${borderClass} ${className}`}
        onClick={onClick}
        style={{ cursor: onClick ? 'pointer' : 'default' }}
      >
        <img
          src={user.profilePicturePath}
          alt={`${getUserDisplayName(user)} profile`}
          className="w-full h-full object-cover"
          onError={(e) => {
            // Hide the image and show fallback
            e.target.style.display = 'none';
            const fallback = e.target.nextSibling;
            if (fallback) {
              fallback.style.display = 'flex';
            }
          }}
        />
        <div 
          className={`w-full h-full bg-gradient-to-br from-blue-500 to-purple-600 rounded-full items-center justify-center hidden`}
        >
          <span className="text-white font-semibold">
            {getUserInitials(user)}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div 
      className={`${sizeClasses[size].split(' ')[0]} ${sizeClasses[size].split(' ')[1]} bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center ${className}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <span className="text-white font-semibold">
        {getUserInitials(user)}
      </span>
    </div>
  );
};

export default UserAvatar;
